module.exports = __webpack_public_path__ + "img/kkb_m290_3w.f2b523a6.png";